import { IDeserializable } from './deserializable.model';

export class Rider implements IDeserializable {
  public id: number;
  public name: string;
  public weightKg?: number;
  public heightCm?: number;

  constructor(id: number, name: string, weightKg?: number, heightCm?: number ) {
    this.id = id;
    this.name = name;
    this.weightKg =weightKg
    this.heightCm = heightCm
  }

  public deserialize(input: any): this {
    return Object.assign(new Rider(input.id, input.name, input.weightKg, input.heightCm), input);
  }
}